// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3735":"4c3e4651971d0986","7415":"7327fce909db381e","7775":"907f5e700a7d6862"}[chunkId] + ".js";
};